import { FaCertificate } from 'react-icons/fa';
import { useT } from '../../hooks/useT';
import styles from './CertificateGrid.module.css';

function CertificateGrid({ items = [] }) {
  const t = useT();

  return (
    <div className={styles.certGrid}>
      {items.map((cert) => (
        <article key={cert.id} className={styles.certCard}>
          <FaCertificate className={styles.certIcon} />
          <div>
            <h3 className={styles.certTitle}>{t(cert.titleKey)}</h3>
            <p className={styles.certIssuer}>{t(cert.issuerKey)}</p>
            {cert.date && <p className={styles.certDate}>{cert.date}</p>}
            {cert.link && (
              <a href={cert.link} target="_blank" rel="noopener noreferrer" className={styles.certLink}>
                {t('certificate.viewLink')}
              </a>
            )}
          </div>
        </article>
      ))}
    </div>
  );
}

export default CertificateGrid;
